import React from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'src/router'
import { DRAWER_ENTITIES, drawerActions } from 'src/state/redux/slice/drawer'
import DNAEmptyWrapper, { EmptyVariant } from './DNAEmpty'

const FolderEmptyLabel = () => {
  const dispatch = useDispatch();
  const location = useLocation()
  const pathTokens = location.pathname.split('/').slice(2)
  const isArchived = location.pathname.includes('archived')
  const isShared = location.pathname.includes('shared')
  const isArchivedOrShared = isArchived || isShared
  const currentFolderId = pathTokens[pathTokens.length - 1];

  const openFileDrawer = (): void => {
    dispatch(drawerActions.toggle({
      entity: DRAWER_ENTITIES.FILES,
      entityId: currentFolderId,
    }))
  };

  const label = !isArchivedOrShared ? 'Add files to organize your content'
    : isArchived ? 'Archive old folders to reduce clutter' : 'Folders shared with you will be listed here'

  return (
    <DNAEmptyWrapper
      emptyVariant={EmptyVariant.CustomLabelEmpty}
      customEmptyLabel={label}
      customEmptyActionLabel={isArchivedOrShared ? undefined : 'Add files'}
      customEmptyOnPress={isArchivedOrShared ? undefined : openFileDrawer}

    />

  )
}

export default FolderEmptyLabel
